import React, {FC} from 'react';
import { EnrichedRightRequest } from 'common';
import { TableCompact } from './TableCompact';
import { TableFull } from './TableFull';

interface ConversationsTableProps {
  rows: any[];
  isCompact: boolean;
  isLoading: boolean;
  isFetchingMore?: boolean;
  sortBy: string;
  sortDirection: 'asc' | 'desc';
  selectedRowId?: string | null;
  checkedRows?: Array<{ conversationId: string; interlocutorId: string; senderId: string }>;
  onCheckboxChange?: (info: { conversationId: string; interlocutorId: string; senderId: string }, checked: boolean) => void;
  getFilterOptions: (field: string) => Array<{ value: string; label: string; selected: boolean; }>;
  onFilterChange: (field: string, selected: string[]) => void;
  onSortChange: (sortBy: string, direction: 'asc' | 'desc') => void;
  onRowClick: (row: any) => void;
  renderUGCCell: (enrichedRightRequests: EnrichedRightRequest[] | undefined) => JSX.Element;
  renderIPRCell: (hasIPR: boolean, iprCount: number) => JSX.Element;
  onToggleFavorite: (conversationId: string) => void;
  onLoadMore?: () => void;
}

export const ConversationsTable: FC<ConversationsTableProps> = ({
  rows,
  isCompact,
  isLoading,
  isFetchingMore,
  sortBy,
  sortDirection,
  selectedRowId,
  checkedRows: selectedRows = [],
  onCheckboxChange,
  getFilterOptions,
  onFilterChange,
  onSortChange,
  onRowClick,
  renderUGCCell,
  renderIPRCell,
  onToggleFavorite,
  onLoadMore,
}) => {
  if (isCompact) {
    return (
      <TableCompact
        rows={rows}
        isLoading={isLoading}
        isFetchingMore={isFetchingMore}
        sortBy={sortBy}
        sortDirection={sortDirection}
        selectedRowId={selectedRowId}
        getFilterOptions={getFilterOptions}
        onFilterChange={onFilterChange}
        onSortChange={onSortChange}
        onRowClick={onRowClick}
        renderIPRCell={renderIPRCell}
        checkedRows={selectedRows}
        onCheckboxChange={onCheckboxChange}
        onToggleFavorite={onToggleFavorite}
        onLoadMore={onLoadMore}
      />
    );
  }

  return (
    <TableFull
      rows={rows}
      isLoading={isLoading}
      isFetchingMore={isFetchingMore}
      sortBy={sortBy}
      sortDirection={sortDirection}
      selectedRowId={selectedRowId}
      getFilterOptions={getFilterOptions}
      onFilterChange={onFilterChange}
      onSortChange={onSortChange}
      onRowClick={onRowClick}
      renderUGCCell={renderUGCCell}
      renderIPRCell={renderIPRCell}
      checkedRows={selectedRows}
      onCheckboxChange={onCheckboxChange}
      onToggleFavorite={onToggleFavorite}
      onLoadMore={onLoadMore}
    />
  );
};
